export function getDtrumInstance() {
    if (!window.dtrum) {
        return;
    }
    return window.dtrum;
}
//# sourceMappingURL=getDtrumInstance.js.map